import { Badge, Box, Text, Tooltip } from '@wix/design-system';
import React from 'react';
import { InfoCircle, StatusAlert } from 'wix-ui-icons-common';
import { useDelayedBiEvent } from '../../../../../hooks/useDelayedBiEvent';
import s from './FeatureRowHeader.scss';
export const FeatureRowHeader = ({ name, description, note, descriptionAsSubtitle, badge, isDescriptionSecondary, nameWeight, onTooltipViewed, disabledInMonthlyLabel, }) => {
    const { logDelayedEvent, interruptDelayedEvent } = useDelayedBiEvent(onTooltipViewed);
    const badgeElement = React.useMemo(() => {
        return (React.createElement(Box, { marginLeft: "6px", marginRight: "6px", inline: true }, typeof badge === 'string' ? (React.createElement(Badge, { skin: "neutralSuccess", size: "tiny" }, badge)) : (badge)));
    }, [badge]);
    return (React.createElement(Box, { direction: "horizontal", verticalAlign: "middle", align: "space-between", width: "100%" },
        React.createElement(Box, { direction: "horizontal", verticalAlign: "middle", gap: "SP1", width: "100%" },
            React.createElement(Box, { direction: "vertical", verticalAlign: "middle", width: "100%" },
                React.createElement(Text, { size: "small", weight: nameWeight },
                    name,
                    badge && badgeElement),
                React.createElement(Text, { size: "tiny", secondary: isDescriptionSecondary },
                    descriptionAsSubtitle && description,
                    note && !disabledInMonthlyLabel && (React.createElement(Box, { inline: true },
                        React.createElement(Text, { size: "tiny", secondary: true }, note)))),
                disabledInMonthlyLabel && (React.createElement(Box, { direction: "horizontal", align: "left", verticalAlign: "middle", marginTop: "3px" },
                    React.createElement(StatusAlert, { style: {
                            color: '#e60023',
                            width: 16,
                            height: 16,
                            marginRight: 4,
                        } }),
                    React.createElement(Text, { size: "tiny", style: { color: '#e60023' } }, disabledInMonthlyLabel))))),
        !descriptionAsSubtitle && (React.createElement(Tooltip, { dataHook: "grid-row-header-tooltip", maxWidth: 300, placement: "right", content: description, className: s.tooltip, onShow: logDelayedEvent, onHide: interruptDelayedEvent },
            React.createElement(Box, { className: s.tooltipIcon },
                React.createElement(InfoCircle, { className: s.tooltipIcon, color: "#7A92A5" }))))));
};
//# sourceMappingURL=FeatureRowHeader.js.map